import React from "react";
import {
    MapPin,
    Mail,
    User
} from "lucide-react";
import {AssignableAppraiser} from "../api/ApiTypes.ts";
import { MetadataRow } from "./MetaDataRow.tsx";

interface AssignableAppraiserItemProps {
    appraiser: AssignableAppraiser;
    isSelected?: boolean;
}

export const AssignableAppraiserItem: React.FC<AssignableAppraiserItemProps> = ({
                                                                                    appraiser,
                                                                                    isSelected = false,
                                                                                }) => {


    return (
        <div className={`border rounded-lg bg-white mb-4 shadow-sm overflow-hidden hover:shadow-md transition-shadow
            ${isSelected ? 'border-blue-500 bg-blue-50' : 'border-slate-200'}`}>
            <div className="p-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="flex-1">
                        <div className="flex items-start space-x-3">
                            <div className={`p-2 rounded-md flex-shrink-0 ${isSelected ? 'bg-blue-100' : 'bg-blue-50'}`}>
                                <User className="h-8 w-8 text-blue-600" />
                            </div>
                            <div>
                                <h3 className="font-medium text-lg lg:text-base text-slate-800 break-all">
                                    {appraiser.firstName} {appraiser.lastName}
                                </h3>
                                <MetadataRow
                                    icon={<MapPin className="h-4 w-4 mr-1 text-blue-700" />}
                                    label="Office:"
                                    value={appraiser.officeAddress}
                                />
                                <MetadataRow
                                    icon={<Mail className="h-4 w-4 mr-1 text-blue-700" />}
                                    label="Email:"
                                    value={appraiser.emailAddress}
                                />
                            </div>
                        </div>
                    </div>

                </div>



                <div className="mt-2 flex flex-wrap gap-2">
                    {appraiser.licensed && (
                        <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700">
                            Licensed
                        </span>
                    )}
                    {appraiser.fhaCertified && (
                        <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700">
                            FHA Certified
                        </span>
                    )}
                    <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">
                        Open Orders: {appraiser.openOrders}
                    </span>
                </div>
            </div>
        </div>
    );
};